module.exports = __webpack_public_path__ + "static/img/third_content_1.abd0e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/third_content_1.png
// module id = xtbq
// module chunks = 34